"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_newest__tech(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "3b91ec37-0872-4796-9c47-0a727c194d72",
    x1: 70,
    y1: 88,
    x2: 142,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdbdbd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f6adb0b8-ee36-44c0-a939-eb6146cc3e26",
    x1: 57.98,
    y1: 106.07,
    x2: 123.98,
    y2: 164.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "340eaedb-a631-4b5d-a876-3b7ee4c6dafa",
    x1: 62.51,
    y1: 151.07,
    x2: 83.85,
    y2: 172.41,
    xlinkHref: "#f6adb0b8-ee36-44c0-a939-eb6146cc3e26"
  })), /*#__PURE__*/React.createElement("title", null, "newest-tech-hi"), /*#__PURE__*/React.createElement("g", {
    id: "e51f0ce7-a1ba-46df-a80d-0f28e24cb990",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "630b6833-3f19-4fb2-9005-d82e199538c8",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.4,160H82.6A12.61,12.61,0,0,1,70,147.4V28.6A12.61,12.61,0,0,1,82.6,16h46.8A12.61,12.61,0,0,1,142,28.6V147.4A12.61,12.61,0,0,1,129.4,160Z",
    transform: "translate(0 0)",
    fill: "url(#3b91ec37-0872-4796-9c47-0a727c194d72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.4,158.2H82.6A12.61,12.61,0,0,1,70,145.6v1.8A12.61,12.61,0,0,0,82.6,160h46.8A12.61,12.61,0,0,0,142,147.4v-1.8A12.61,12.61,0,0,1,129.4,158.2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 37.67,
    width: 72,
    height: 2.18
  })), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 33.93,
    width: 72,
    height: 3.74,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 98.8,
    cy: 124,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 127.6,
    cy: 124,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 113.2,
    cy: 124,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 84.4,
    cy: 124,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 113.2,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120.4,
    cy: 113.2,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 134.8,
    cy: 113.2,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 91.6,
    cy: 113.2,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.2,
    cy: 113.2,
    r: 3.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.4,124a3.6,3.6,0,0,0,3.6,3.6v-7.2A3.6,3.6,0,0,0,138.4,124Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6,124a3.6,3.6,0,0,0-3.6-3.6v7.2A3.6,3.6,0,0,0,73.6,124Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 98.8,
    cy: 102.4,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 127.6,
    cy: 102.4,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 113.2,
    cy: 102.4,
    r: 3.6
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 84.4,
    cy: 102.4,
    r: 3.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.4,102.4A3.6,3.6,0,0,0,142,106V98.8A3.6,3.6,0,0,0,138.4,102.4Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6,102.4A3.6,3.6,0,0,0,70,98.8V106A3.6,3.6,0,0,0,73.6,102.4Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8,100.6a3.59,3.59,0,0,1,3.47,2.7,3.38,3.38,0,0,0,.13-.9,3.6,3.6,0,0,0-7.2,0,3.38,3.38,0,0,0,.13.9A3.59,3.59,0,0,1,98.8,100.6Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.6,100.6a3.59,3.59,0,0,1,3.47,2.7,3.38,3.38,0,0,0,.13-.9,3.6,3.6,0,1,0-7.2,0,3.38,3.38,0,0,0,.13.9A3.59,3.59,0,0,1,127.6,100.6Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.2,100.6a3.59,3.59,0,0,1,3.47,2.7,3.38,3.38,0,0,0,.13-.9,3.6,3.6,0,1,0-7.2,0,3.38,3.38,0,0,0,.13.9A3.59,3.59,0,0,1,113.2,100.6Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4,100.6a3.59,3.59,0,0,1,3.47,2.7,3.38,3.38,0,0,0,.13-.9,3.6,3.6,0,1,0-7.2,0,3.38,3.38,0,0,0,.13.9A3.59,3.59,0,0,1,84.4,100.6Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2,111.4a3.59,3.59,0,0,1,3.47,2.7,3.38,3.38,0,0,0,.13-.9,3.6,3.6,0,1,0-7.2,0,3.38,3.38,0,0,0,.13.9A3.59,3.59,0,0,1,77.2,111.4Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,111.4a3.59,3.59,0,0,1,3.47,2.7,3.38,3.38,0,0,0,.13-.9,3.6,3.6,0,0,0-7.2,0,3.38,3.38,0,0,0,.13.9A3.59,3.59,0,0,1,91.6,111.4Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,111.4a3.59,3.59,0,0,1,3.47,2.7,3.38,3.38,0,0,0,.13-.9,3.6,3.6,0,1,0-7.2,0,3.38,3.38,0,0,0,.13.9A3.59,3.59,0,0,1,106,111.4Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.4,111.4a3.59,3.59,0,0,1,3.47,2.7,3.38,3.38,0,0,0,.13-.9,3.6,3.6,0,1,0-7.2,0,3.38,3.38,0,0,0,.13.9A3.59,3.59,0,0,1,120.4,111.4Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.8,111.4a3.59,3.59,0,0,1,3.47,2.7,3.38,3.38,0,0,0,.13-.9,3.6,3.6,0,1,0-7.2,0,3.38,3.38,0,0,0,.13.9A3.59,3.59,0,0,1,134.8,111.4Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.4,102.4a3.38,3.38,0,0,0,.13.9,3.59,3.59,0,0,1,3.47-2.7V98.8A3.6,3.6,0,0,0,138.4,102.4Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.47,103.3a3.38,3.38,0,0,0,.13-.9A3.6,3.6,0,0,0,70,98.8v1.8A3.59,3.59,0,0,1,73.47,103.3Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8,122.2a3.59,3.59,0,0,1,3.47,2.7,3.38,3.38,0,0,0,.13-.9,3.6,3.6,0,0,0-7.2,0,3.38,3.38,0,0,0,.13.9A3.59,3.59,0,0,1,98.8,122.2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.6,122.2a3.59,3.59,0,0,1,3.47,2.7,3.38,3.38,0,0,0,.13-.9,3.6,3.6,0,1,0-7.2,0,3.38,3.38,0,0,0,.13.9A3.59,3.59,0,0,1,127.6,122.2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.2,122.2a3.59,3.59,0,0,1,3.47,2.7,3.38,3.38,0,0,0,.13-.9,3.6,3.6,0,1,0-7.2,0,3.38,3.38,0,0,0,.13.9A3.59,3.59,0,0,1,113.2,122.2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4,122.2a3.59,3.59,0,0,1,3.47,2.7A3.38,3.38,0,0,0,88,124a3.6,3.6,0,0,0-7.2,0,3.38,3.38,0,0,0,.13.9A3.59,3.59,0,0,1,84.4,122.2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.4,124a3.38,3.38,0,0,0,.13.9,3.59,3.59,0,0,1,3.47-2.7v-1.8A3.6,3.6,0,0,0,138.4,124Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.47,124.9a3.38,3.38,0,0,0,.13-.9,3.6,3.6,0,0,0-3.6-3.6v1.8A3.59,3.59,0,0,1,73.47,124.9Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70,91V147.4A12.61,12.61,0,0,0,82.6,160h46.8a12.62,12.62,0,0,0,12.37-10.23L82.24,90.93Z",
    transform: "translate(0 0)",
    fill: "url(#f6adb0b8-ee36-44c0-a939-eb6146cc3e26)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78,176H62a5.46,5.46,0,0,1-5.41-4.77l-1.82-14.57a2.19,2.19,0,0,1,2.17-2.45H83.08a2.19,2.19,0,0,1,2.16,2.45l-1.82,14.57A5.46,5.46,0,0,1,78,176Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.08,110.63H56.93a2.19,2.19,0,0,1-1.64-.74,2.22,2.22,0,0,1-.53-1.71l1.82-14.57A5.46,5.46,0,0,1,62,88.83H78a5.46,5.46,0,0,1,5.41,4.78l1.82,14.57a2.22,2.22,0,0,1-.53,1.71A2.19,2.19,0,0,1,83.08,110.63Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.16,105.18H55.84l-.71,0L55,106.3q.41,0,.84,0H84.16q.44,0,.84,0l-.13-1.1Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.16,158.57H55.84a12,12,0,0,1-12-12V118.25a12,12,0,0,1,12-12H84.16a12,12,0,0,1,12,12v28.33A12,12,0,0,1,84.16,158.57Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,156.39H57a11,11,0,0,1-11-11v-26a11,11,0,0,1,11-11H83a11,11,0,0,1,11,11v26A11,11,0,0,1,83,156.39Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.16,157.48H55.84a12,12,0,0,1-12-12v1.09a12,12,0,0,0,12,12H84.16a12,12,0,0,0,12-12v-1.09A12,12,0,0,1,84.16,157.48Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.26,133.44H70a1,1,0,0,1-1-1V115.8a1,1,0,1,1,2,0v15.6H82.26a1,1,0,1,1,0,2Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.26,132.82H70a1,1,0,0,1-1-1v.62a1,1,0,0,0,1,1H82.26a1,1,0,0,0,1-1,.81.81,0,0,0-.06-.31A1,1,0,0,1,82.26,132.82Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.42,171.23,85,158.57H55L72.45,176H78A5.46,5.46,0,0,0,83.42,171.23Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#340eaedb-a631-4b5d-a876-3b7ee4c6dafa)"
  })));
}

var _default = ic_newest__tech;
exports.default = _default;